import { convertToDarkerRgba, convertToDarkRgba, } from "../../theme/src";
export const getColorFromTheme = ({ color, theme, }) => {
    if (color in theme.colors) {
        return theme.colors[color];
    }
    return color;
};
export const getBuilderButtonHoveredStyle = ({ builderProps, theme, }) => {
    if (!builderProps ||
        !(builderProps === null || builderProps === void 0 ? void 0 : builderProps.builderBackgroundColor) ||
        !(builderProps === null || builderProps === void 0 ? void 0 : builderProps.builderTextColor)) {
        return {};
    }
    const builderBackgroundColor = getColorFromTheme({
        color: builderProps.builderBackgroundColor,
        theme,
    });
    const builderTextColor = getColorFromTheme({
        color: builderProps.builderTextColor,
        theme,
    });
    return {
        backgroundColor: convertToDarkRgba(builderBackgroundColor),
        color: builderTextColor,
    };
};
export const getBuilderButtonPressedStyle = ({ builderProps, theme, }) => {
    if (!builderProps ||
        !(builderProps === null || builderProps === void 0 ? void 0 : builderProps.builderBackgroundColor) ||
        !(builderProps === null || builderProps === void 0 ? void 0 : builderProps.builderTextColor)) {
        return {};
    }
    const builderBackgroundColor = getColorFromTheme({
        color: builderProps.builderBackgroundColor,
        theme,
    });
    const builderTextColor = getColorFromTheme({
        color: builderProps.builderTextColor,
        theme,
    });
    return {
        backgroundColor: convertToDarkerRgba(builderBackgroundColor),
        color: builderTextColor,
    };
};
export const getButtonDisabledStyle = ({ builderProps, hasChildren, size, theme, themeButton, }) => (Object.assign(Object.assign({}, getButtonStyle({ builderProps, hasChildren, size, theme, themeButton })), themeButton.disabled));
export const getButtonHoveredStyle = ({ builderProps, hasChildren, size, theme, themeButton, }) => (Object.assign(Object.assign(Object.assign({}, getButtonStyle({ builderProps, hasChildren, size, theme, themeButton })), (themeButton.hovered
    ? {
        backgroundColor: getColorFromTheme({
            color: themeButton.hovered.bg,
            theme,
        }),
        color: getColorFromTheme({ color: themeButton.hovered.color, theme }),
    }
    : {})), getBuilderButtonHoveredStyle({ builderProps, theme })));
export const getButtonPressedStyle = ({ builderProps, hasChildren, size, theme, themeButton, }) => (Object.assign(Object.assign(Object.assign({}, getButtonStyle({ builderProps, hasChildren, size, theme, themeButton })), (themeButton.pressed
    ? {
        backgroundColor: getColorFromTheme({
            color: themeButton.pressed.bg,
            theme,
        }),
        color: getColorFromTheme({ color: themeButton.pressed.color, theme }),
    }
    : {})), getBuilderButtonPressedStyle({ builderProps, theme })));
export const getButtonStyle = ({ builderProps, hasChildren, size, theme, themeButton, }) => {
    const { builderBackgroundColor, builderBorderColor, builderBorderRadius, builderBorderWidth, builderFontFamily, builderFontSize, builderLetterSpacing, builderPadding, builderTextColor, } = builderProps || {};
    return {
        backgroundColor: getColorFromTheme({
            color: builderBackgroundColor || themeButton.bg,
            theme,
        }),
        borderColor: builderBorderColor !== null && builderBorderColor !== void 0 ? builderBorderColor : 'transparent',
        borderRadius: builderBorderRadius !== null && builderBorderRadius !== void 0 ? builderBorderRadius : themeButton.borderRadius,
        borderWidth: builderBorderWidth !== null && builderBorderWidth !== void 0 ? builderBorderWidth : 0,
        color: getColorFromTheme({
            color: builderTextColor || themeButton.color,
            theme,
        }),
        fontFamily: builderFontFamily !== null && builderFontFamily !== void 0 ? builderFontFamily : 'inherit',
        fontSize: builderFontSize !== null && builderFontSize !== void 0 ? builderFontSize : themeButton.fontSize,
        fontWeight: theme.fontWeights[themeButton.fontWeight],
        letterSpacing: builderLetterSpacing !== null && builderLetterSpacing !== void 0 ? builderLetterSpacing : themeButton.letterSpacing,
        opacity: themeButton.opacity,
        padding: builderPadding ||
            (hasChildren
                ? `0px ${size === 'large' ? theme.space[4] : theme.space[3]}px`
                : `${theme.space[1]}px`),
    };
};
//# sourceMappingURL=utils.js.map